export default {
  events: '/dashboard/events',
};
